'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    TravelerSelection: ()=>TravelerSelection
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const external_constants_cjs_namespaceObject = require("../constants.cjs");
const external_TravelerSelectionDesktop_cjs_namespaceObject = require("./TravelerSelectionDesktop.cjs");
var external_TravelerSelectionDesktop_cjs_default = /*#__PURE__*/ __webpack_require__.n(external_TravelerSelectionDesktop_cjs_namespaceObject);
const external_TravelerSelectionMobile_cjs_namespaceObject = require("./TravelerSelectionMobile.cjs");
var external_TravelerSelectionMobile_cjs_default = /*#__PURE__*/ __webpack_require__.n(external_TravelerSelectionMobile_cjs_namespaceObject);
const useTravelerSelection_cjs_namespaceObject = require("../hooks/useTravelerSelection.cjs");
const index_cjs_namespaceObject = require("../../InputButton/index.cjs");
function TravelerSelection({ ageSelectEnabled, disclaimer, errorMessage, initialValues, isInternationalFlight, isHotel = false, isMobile = false, isTravelerSelectionDisabled = false, isWhiteLabel, lapInfantLabel, maxAdults, maxChildren, maxTravelers = external_constants_cjs_namespaceObject.DEFAULT_MAX_TRAVELERS, maxRooms, maxRoomsMessage, maxRoomsUrl, fireMaxRoomsOnClick, roomsEnabled, shouldCountLapInfant, subLabelMap, onChange, shouldAllowInternationalLapInfants, ...props }) {
    const useTravelerSelectionProps = (0, external_react_namespaceObject.useMemo)(()=>({
            initialValues: {
                rooms: roomsEnabled ? 1 : 0,
                ...initialValues
            },
            ageSelectEnabled: !!ageSelectEnabled,
            errorMessage,
            isInternationalFlight: !!isInternationalFlight,
            isWhiteLabel,
            maxTravelers,
            shouldCountLapInfant,
            shouldAllowInternationalLapInfants
        }), [
        ageSelectEnabled,
        errorMessage,
        initialValues,
        isInternationalFlight,
        isWhiteLabel,
        maxTravelers,
        roomsEnabled,
        shouldAllowInternationalLapInfants,
        shouldCountLapInfant
    ]);
    const [isOpen, setIsOpen] = (0, external_react_namespaceObject.useState)(false);
    const state = (0, useTravelerSelection_cjs_namespaceObject.useTravelerSelection)(useTravelerSelectionProps);
    const setRoomsRef = (0, external_react_namespaceObject.useRef)(state.setRooms);
    setRoomsRef.current = state.setRooms;
    (0, external_react_namespaceObject.useEffect)(()=>{
        const rooms = roomsEnabled ? useTravelerSelectionProps.initialValues.rooms || 1 : 0;
        setRoomsRef.current(rooms);
    }, [
        roomsEnabled,
        useTravelerSelectionProps.initialValues.rooms
    ]);
    function handleOpen(val) {
        setIsOpen(val ?? true);
        if (onChange) onChange(state);
    }
    function handleClose() {
        setIsOpen(false);
        if (onChange) onChange(state);
    }
    const TravelerSelectionProps = {
        ageSelectEnabled,
        disclaimer,
        handleClose,
        isHotel,
        lapInfantLabel,
        maxAdults,
        maxChildren,
        maxRooms,
        fireMaxRoomsOnClick,
        maxRoomsMessage,
        maxRoomsUrl,
        roomsEnabled,
        shouldCountLapInfant,
        state,
        subLabelMap,
        onChange,
        ...props
    };
    const InputTrigger = (0, external_react_namespaceObject.useCallback)((props)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
            ...props,
            className: "w-full",
            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.InputButton, {
                "data-testid": "traveler-selection-input",
                iconLeft: 'person',
                label: "Travelers",
                value: state.label,
                size: 'lg',
                className: "w-full",
                errorMessage: state.errorMessage,
                isDisabled: isTravelerSelectionDisabled
            })
        }), [
        state.label,
        state.errorMessage,
        isTravelerSelectionDisabled
    ]);
    return isMobile ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_TravelerSelectionMobile_cjs_default(), {
        ...TravelerSelectionProps,
        isOpen: isOpen,
        handleOpen: handleOpen,
        isDisabled: isTravelerSelectionDisabled
    }) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_TravelerSelectionDesktop_cjs_default(), {
        ...TravelerSelectionProps,
        isOpen: isOpen,
        renderInput: InputTrigger,
        handleOpen: handleOpen
    });
}
exports.TravelerSelection = __webpack_exports__.TravelerSelection;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "TravelerSelection"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
